import React from 'react'

export const Proyectos = () => {
  return (
    <>
    <div className='banner'>
      <div className='fondo-banner'></div>
      <h1>Proyectos</h1>
    </div>

    <div className='appear'>
      Seccion en progreso
    </div>
    </>
  )
}
